export default __webpack_public_path__ + "b84a711d70c4c502d796deeba85cba67.png";